import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const LessonSummaryRatingApiUtils = {
  create(summaryId, rate) {
    return xhr(ApiConstants.Base + 'summaries/' + summaryId + '/ratings', {
      method: 'post',
      body: JSON.stringify({
        rate,
      }),
    });
  },
};

export default LessonSummaryRatingApiUtils;
